module.exports = __webpack_public_path__ + "img/chairs-and-chaises.1ceac27.jpg";